export default __webpack_public_path__ + "static/media/Introduction-people.6451673d.svg";